(function () {
  'use strict';

  // ——— Gallery ———————————————————————————————————————————
  document.querySelectorAll('[id^="product-gallery-"]').forEach(function (gallery) {
    var thumbs   = gallery.querySelectorAll('.product__thumb');
    var medias   = gallery.querySelectorAll('.product__media');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = this.dataset.mediaIndex;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        medias.forEach(function (m) {
          m.classList.remove('is-active');
          m.setAttribute('aria-hidden', 'true');
        });
        this.classList.add('is-active');
        var target = gallery.querySelector('.product__media[data-media-index="' + idx + '"]');
        if (target) {
          target.classList.add('is-active');
          target.setAttribute('aria-hidden', 'false');
        }
      });
    });
  });

  // ——— Variant selection ————————————————————————————————
  var productData = window.__productData;
  if (!productData) return;

  var variants   = productData.variants;
  var sid        = productData.sectionId;
  var selected   = {};

  var variantIdInput  = document.getElementById('product-variant-id-' + sid);
  var priceEl         = document.getElementById('product-price-' + sid);
  var addPriceEl      = document.getElementById('add-to-bag-price-' + sid);
  var addBtn          = document.querySelector('[data-add-to-cart]');
  var addLabel        = addBtn && addBtn.querySelector('.product__add-label');
  var stockEl         = document.getElementById('product-stock-' + sid);

  function formatMoney(cents) {
    var naira = Math.round(cents / 100);
    return '₦' + naira.toLocaleString('en-NG');
  }

  function updateVariant() {
    var match = variants.find(function (v) {
      return Object.keys(selected).every(function (pos) {
        return v['option' + pos] === selected[pos];
      });
    });
    if (!match) return;

    if (variantIdInput)  variantIdInput.value = match.id;
    if (priceEl)         priceEl.textContent  = formatMoney(match.price);
    if (addPriceEl)      addPriceEl.textContent = formatMoney(match.price);

    if (addBtn) {
      if (match.available) {
        addBtn.disabled = false;
        if (addLabel) addLabel.textContent = 'ADD TO BAG';
        if (addPriceEl) addPriceEl.style.display = '';
      } else {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'SOLD OUT';
        if (addPriceEl) addPriceEl.style.display = 'none';
      }
    }
  }

  document.querySelectorAll('.size-btn, .swatch').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (this.getAttribute('aria-disabled') === 'true') return;

      var pos   = this.dataset.optionPosition;
      var val   = this.dataset.value;
      var group = this.closest('.product__sizes, .product__swatches');

      if (group) {
        group.querySelectorAll('.size-btn, .swatch').forEach(function (b) {
          b.classList.remove('is-selected', 'is-active');
          b.setAttribute('aria-pressed', 'false');
        });
      }
      this.classList.add(this.classList.contains('swatch') ? 'is-active' : 'is-selected');
      this.setAttribute('aria-pressed', 'true');

      selected[pos] = val;

      var labelEl = document.querySelector('[data-selected-value="' + pos + '"], [data-selected-size="' + pos + '"]');
      if (labelEl) labelEl.textContent = val;

      updateVariant();
    });
  });

  // ——— Buy Now ——————————————————————————————————————————
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = variantIdInput && variantIdInput.value;
      if (id) {
        window.location.href = '/cart/' + id + ':1?checkout=true';
      }
    });
  });

  // ——— Share ————————————————————————————————————————————
  document.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url:   window.location.href
        });
      } else {
        navigator.clipboard && navigator.clipboard.writeText(window.location.href).then(function () {
          btn.textContent = 'Link copied!';
          setTimeout(function () { btn.innerHTML = btn.innerHTML; }, 2000);
        });
      }
    });
  });

})();
